<div class="flex-main-container">

  <div class="flex-container">

  <div class="flex-column">
    <lm-filter-builder-field-lookup
      id="subject"
      [qualifier]="filterRow.subject"
      [businessClass]="businessClass"
      [lookupUrl]="lookupUrl"
      [fieldSearchUrl]="fieldSearchUrl"
      [lplValidationUrl]="lplValidationUrl"
      [includeAuditFields]="includeAuditFields"
      [index]="index"
      position="subject"
      mode="Fields"
      (fieldSelectionEvent)="handleFieldLookUpEvent($event, 'subject')"
    >
    </lm-filter-builder-field-lookup>
  </div>

  <div class="flex-column">
    <div class="field">
      <ng-container *ngIf="!hasPredicate">
        <label soho-label>{{'Condition' | translate}}</label>
      </ng-container>
      <ng-container *ngIf="hasPredicate">
        <label soho-label>{{'State' | translate}}</label>
      </ng-container>
      <select
        soho-dropdown noSearch
        [attr.id]="operatorId"
        [attr.bindId]="'bindId'"
        [readonly]="null"
        [(ngModel)]="filterRow.condition"
        (change)="hidePredicate()"
      >
        <option class="clear"></option>
        <option *ngFor="let item of conditions" [value]="item.value">{{item.label}}</option>
      </select>
    </div>
  </div>

  <ng-container *ngIf="!hasPredicate">
    <div class="field flex-column">
      <label soho-label>{{'Literal' | translate}}</label>
      <input
              type="checkbox"
              soho-checkbox
              [attr.id]="checkboxId"
              [attr.bindId]="checkboxId"
              [(ngModel)]="filterRow.literal"
              (change)="clearField()"
      />
      <label
              soho-label
              [forCheckBox]=true
              [attr.for]="checkboxId"
      ></label>
    </div>
    <div class="flex-column">
    <ng-container *ngIf="!filterRow.literal">
      <lm-filter-builder-field-lookup
        id="predicate"
        class="literal-input"
        [qualifier]="filterRow.predicate"
        [businessClass]="businessClass"
        [lookupUrl]="lookupUrl"
        [fieldSearchUrl]="fieldSearchUrl"
        [lplValidationUrl]="lplValidationUrl"
        [includeAuditFields]="includeAuditFields"
        [index]="index"
        position="predicate"
        mode="Fields"
        (fieldSelectionEvent)="handleFieldLookUpEvent($event, 'predicate')"
      >
      </lm-filter-builder-field-lookup>
    </ng-container>
    <ng-container *ngIf="filterRow.literal">
      <div class="field literal-input">
        <label soho-label>{{'Value' | translate}}</label>
        <input
          [attr.id]="literalId"
          [attr.bindId]="filterRow.predicate"
          [attr.type]="'text'"
          [(ngModel)]="filterRow.predicate.text"
          soho-alert
        />
      </div>
    </ng-container>

  </div>
  </ng-container>

  <ng-container *ngIf="hasPredicate">
    <div class="field flex-column"></div>
    <div class="field flex-column"></div>
  </ng-container>
</div>

  <div class="flex-container">

  <div class="flex-column delete-btn">
    <div class="field">
      <div class="label">&nbsp;</div>
      <button 
        soho-button="icon"
        (click)="onRemoveButtonEvent()"
        icon="close"
      ><span #LmButtonIcon class="lm-button-icon" role="presentation" aria-hidden="true"></span></button>
    </div>
  </div>
</div>
</div>

